import {
  Users, Globe, MapPin, Calendar as CalendarIcon,
  Wallet, Compass, Heart, Settings, Navigation,
} from 'lucide-react';

export const TRAVELER_TYPES = [
  { value: 'Solo', label: 'Solo', icon: '🧳', desc: 'Just me' },
  { value: 'Couple', label: 'Couple', icon: '💑', desc: 'Romantic getaway' },
  { value: 'Family', label: 'Family', icon: '👨‍👩‍👧‍👦', desc: 'With kids' },
  { value: 'Friends', label: 'Friends', icon: '👯', desc: 'Group trip' },
];

export const BUDGET_OPTIONS = [
  { value: 'low', label: 'Budget', desc: 'Affordable options', icon: '💰' },
  { value: 'medium', label: 'Moderate', desc: 'Balanced spending', icon: '💎' },
  { value: 'flexible', label: 'Flexible', desc: 'No limits', icon: '✨' },
];

export const TRAVEL_STYLES = [
  { value: 'budget-friendly', label: 'Budget-Friendly' },
  { value: 'family-friendly', label: 'Family-Friendly' },
  { value: 'adventure', label: 'Adventure' },
  { value: 'relaxed', label: 'Relaxed' },
  { value: 'cultural', label: 'Cultural/Historical' },
  { value: 'business', label: 'Business' },
  { value: 'events', label: 'Events' },
];

export const INTERESTS = [
  { value: 'sightseeing', label: 'Sightseeing' },
  { value: 'historical-sites', label: 'Historical Sites' },
  { value: 'free-attractions', label: 'Free Attractions' },
  { value: 'food-restaurants', label: 'Food & Restaurants' },
  { value: 'nightlife', label: 'Nightlife' },
  { value: 'nature', label: 'Nature & Outdoors' },
  { value: 'shopping', label: 'Shopping' },
  { value: 'art-museums', label: 'Art & Museums' },
  { value: 'business', label: 'Business' },
  { value: 'events', label: 'Events & Festivals' },
];

export const PREFERENCES = [
  { value: 'safety-focused', label: 'Safety-Focused', icon: '🛡️' },
  { value: 'weather-sensitive', label: 'Weather-Sensitive', icon: '🌤️' },
  { value: 'accessibility', label: 'Accessibility Needs', icon: '♿' },
  { value: 'vegetarian', label: 'Vegetarian/Vegan Food', icon: '🥗' },
  { value: 'pet-friendly', label: 'Pet-Friendly', icon: '🐾' },
];

export const COUNTRIES_DATA = {
  'Japan': ['Tokyo', 'Kyoto', 'Osaka', 'Hiroshima', 'Nara', 'Yokohama', 'Sapporo', 'Fukuoka'],
  'France': ['Paris', 'Nice', 'Lyon', 'Marseille', 'Bordeaux', 'Strasbourg', 'Toulouse'],
  'Italy': ['Rome', 'Venice', 'Florence', 'Milan', 'Naples', 'Amalfi', 'Cinque Terre'],
  'Spain': ['Barcelona', 'Madrid', 'Seville', 'Valencia', 'Granada', 'Bilbao', 'Malaga'],
  'United States': ['New York', 'Los Angeles', 'San Francisco', 'Miami', 'Las Vegas', 'Chicago', 'Hawaii', 'Seattle'],
  'United Kingdom': ['London', 'Edinburgh', 'Manchester', 'Liverpool', 'Oxford', 'Cambridge', 'Bath'],
  'Greece': ['Athens', 'Santorini', 'Mykonos', 'Crete', 'Rhodes', 'Corfu', 'Thessaloniki'],
  'Thailand': ['Bangkok', 'Phuket', 'Chiang Mai', 'Krabi', 'Koh Samui', 'Pattaya', 'Ayutthaya'],
  'Indonesia': ['Bali', 'Jakarta', 'Yogyakarta', 'Lombok', 'Komodo', 'Ubud'],
  'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Gold Coast', 'Cairns', 'Adelaide'],
  'United Arab Emirates': ['Dubai', 'Abu Dhabi', 'Sharjah'],
  'Portugal': ['Lisbon', 'Porto', 'Algarve', 'Sintra', 'Madeira', 'Azores'],
  'Mexico': ['Mexico City', 'Cancun', 'Playa del Carmen', 'Tulum', 'Oaxaca', 'Guadalajara'],
  'Turkey': ['Istanbul', 'Cappadocia', 'Antalya', 'Izmir', 'Bodrum', 'Ephesus'],
  'Morocco': ['Marrakech', 'Fes', 'Casablanca', 'Chefchaouen', 'Tangier', 'Essaouira'],
  'Egypt': ['Cairo', 'Luxor', 'Aswan', 'Alexandria', 'Sharm El Sheikh', 'Hurghada'],
  'India': ['Delhi', 'Mumbai', 'Jaipur', 'Goa', 'Agra', 'Varanasi', 'Kerala', 'Udaipur'],
  'Vietnam': ['Hanoi', 'Ho Chi Minh City', 'Da Nang', 'Hoi An', 'Ha Long Bay', 'Nha Trang'],
  'South Korea': ['Seoul', 'Busan', 'Jeju Island', 'Gyeongju', 'Incheon'],
  'Singapore': ['Singapore'],
  'Malaysia': ['Kuala Lumpur', 'Penang', 'Langkawi', 'Malacca', 'Borneo'],
  'New Zealand': ['Auckland', 'Queenstown', 'Wellington', 'Rotorua', 'Christchurch'],
  'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Banff', 'Quebec City', 'Victoria'],
  'Germany': ['Berlin', 'Munich', 'Frankfurt', 'Hamburg', 'Cologne', 'Heidelberg'],
  'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht'],
  'Switzerland': ['Zurich', 'Geneva', 'Lucerne', 'Interlaken', 'Zermatt', 'Bern'],
  'Austria': ['Vienna', 'Salzburg', 'Innsbruck', 'Hallstatt'],
  'Czech Republic': ['Prague', 'Cesky Krumlov', 'Brno'],
  'Croatia': ['Dubrovnik', 'Split', 'Zagreb', 'Plitvice Lakes', 'Hvar'],
  'Iceland': ['Reykjavik', 'Blue Lagoon', 'Golden Circle'],
  'Norway': ['Oslo', 'Bergen', 'Tromso', 'Fjords'],
  'Sweden': ['Stockholm', 'Gothenburg', 'Malmo'],
  'Denmark': ['Copenhagen', 'Aarhus'],
  'Finland': ['Helsinki', 'Lapland', 'Rovaniemi'],
  'Ireland': ['Dublin', 'Galway', 'Cork', 'Killarney'],
  'Scotland': ['Edinburgh', 'Glasgow', 'Highlands', 'Isle of Skye'],
  'Brazil': ['Rio de Janeiro', 'Sao Paulo', 'Salvador', 'Florianopolis', 'Iguazu Falls'],
  'Argentina': ['Buenos Aires', 'Patagonia', 'Mendoza', 'Bariloche', 'Ushuaia'],
  'Chile': ['Santiago', 'Torres del Paine', 'Valparaiso', 'Atacama Desert', 'Easter Island'],
  'Peru': ['Lima', 'Cusco', 'Machu Picchu', 'Sacred Valley', 'Arequipa'],
  'Colombia': ['Bogota', 'Cartagena', 'Medellin', 'Santa Marta'],
  'South Africa': ['Cape Town', 'Johannesburg', 'Kruger National Park', 'Durban', 'Garden Route'],
  'Kenya': ['Nairobi', 'Masai Mara', 'Mombasa', 'Amboseli'],
  'Tanzania': ['Zanzibar', 'Serengeti', 'Kilimanjaro', 'Dar es Salaam'],
  'Maldives': ['Male', 'Maafushi', 'Various Atolls'],
  'Sri Lanka': ['Colombo', 'Kandy', 'Galle', 'Ella', 'Sigiriya'],
  'Nepal': ['Kathmandu', 'Pokhara', 'Everest Region', 'Chitwan'],
  'Philippines': ['Manila', 'Cebu', 'Palawan', 'Boracay', 'Bohol'],
  'Cambodia': ['Siem Reap', 'Phnom Penh', 'Angkor Wat'],
  'Laos': ['Luang Prabang', 'Vientiane'],
  'Myanmar': ['Yangon', 'Bagan', 'Mandalay', 'Inle Lake'],
  'China': ['Beijing', 'Shanghai', 'Hong Kong', 'Xian', 'Guilin', 'Chengdu'],
  'Taiwan': ['Taipei', 'Kaohsiung', 'Taichung', 'Jiufen'],
  'Russia': ['Moscow', 'St Petersburg', 'Kazan'],
  'Poland': ['Warsaw', 'Krakow', 'Gdansk', 'Wroclaw'],
  'Hungary': ['Budapest', 'Eger'],
  'Belgium': ['Brussels', 'Bruges', 'Ghent', 'Antwerp'],
  'Luxembourg': ['Luxembourg City'],
  'Monaco': ['Monte Carlo'],
  'Malta': ['Valletta', 'Mdina', 'Gozo'],
  'Cyprus': ['Nicosia', 'Paphos', 'Limassol'],
  'Israel': ['Tel Aviv', 'Jerusalem', 'Dead Sea', 'Haifa'],
  'Jordan': ['Amman', 'Petra', 'Wadi Rum', 'Dead Sea'],
  'Oman': ['Muscat', 'Salalah'],
  'Qatar': ['Doha'],
  'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca', 'Medina'],
  'Bahrain': ['Manama'],
  'Kuwait': ['Kuwait City'],
};

export const COUNTRIES = Object.keys(COUNTRIES_DATA).sort();

export const NATIONALITIES = [
  'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Argentine', 
  'Armenian', 'Australian', 'Austrian', 'Azerbaijani', 'Bahamian', 'Bahraini', 
  'Bangladeshi', 'Barbadian', 'Belarusian', 'Belgian', 'Belizean', 'Beninese', 
  'Bhutanese', 'Bolivian', 'Bosnian', 'Brazilian', 'British', 'Bruneian', 
  'Bulgarian', 'Burkinabe', 'Burmese', 'Burundian', 'Cambodian', 'Cameroonian', 
  'Canadian', 'Cape Verdean', 'Central African', 'Chadian', 'Chilean', 'Chinese', 
  'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 
  'Cypriot', 'Czech', 'Danish', 'Djiboutian', 'Dominican', 'Dutch', 'Ecuadorean', 
  'Egyptian', 'Emirati', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian', 
  'Fijian', 'Filipino', 'Finnish', 'French', 'Gabonese', 'Gambian', 'Georgian', 
  'German', 'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinean', 'Guyanese', 
  'Haitian', 'Honduran', 'Hungarian', 'Icelandic', 'Indian', 'Indonesian', 
  'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian', 'Jamaican', 
  'Japanese', 'Jordanian', 'Kazakh', 'Kenyan', 'Korean', 'Kuwaiti', 'Kyrgyz', 
  'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner', 
  'Lithuanian', 'Luxembourgish', 'Macedonian', 'Malagasy', 'Malawian', 'Malaysian', 
  'Maldivian', 'Malian', 'Maltese', 'Mauritanian', 'Mauritian', 'Mexican', 
  'Moldovan', 'Monacan', 'Mongolian', 'Montenegrin', 'Moroccan', 'Mozambican', 
  'Namibian', 'Nepalese', 'New Zealander', 'Nicaraguan', 'Nigerian', 'Norwegian', 
  'Omani', 'Pakistani', 'Palauan', 'Palestinian', 'Panamanian', 'Papua New Guinean', 
  'Paraguayan', 'Peruvian', 'Polish', 'Portuguese', 'Qatari', 'Romanian', 
  'Russian', 'Rwandan', 'Saint Lucian', 'Salvadoran', 'Samoan', 'Saudi', 
  'Scottish', 'Senegalese', 'Serbian', 'Seychellois', 'Sierra Leonean', 
  'Singaporean', 'Slovak', 'Slovenian', 'Solomon Islander', 'Somali', 
  'South African', 'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamese', 'Swazi', 
  'Swedish', 'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 
  'Togolese', 'Tongan', 'Trinidadian', 'Tunisian', 'Turkish', 'Turkmen', 
  'Tuvaluan', 'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbek', 'Venezuelan', 
  'Vietnamese', 'Welsh', 'Yemeni', 'Zambian', 'Zimbabwean'
].sort();

export const STEPS = [
  { id: 1, title: 'Travelers', icon: Users },
  { id: 2, title: 'Nationality', icon: Globe },
  { id: 3, title: 'Origin', icon: Navigation },
  { id: 4, title: 'Destination', icon: MapPin },
  { id: 5, title: 'Dates', icon: CalendarIcon },
  { id: 6, title: 'Budget', icon: Wallet },
  { id: 7, title: 'Style', icon: Compass },
  { id: 8, title: 'Interests', icon: Heart },
  { id: 9, title: 'Preferences', icon: Settings },
];
